import React, { ChangeEvent, useEffect, useRef } from 'react';
import { CButton, CSpinner } from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';
import CIcon from '@coreui/icons-react';
import { ChatNewMessageUpdate, SendMessage } from '../../actions/chat.action';
import { selectChatData } from '../../selectors/chat.selector';
import { selectUserProfile } from '../../../store/selectors/profile.selectors';
import { GLYMPSE_PRO_CHAT_ORIGIN } from '../../../shared/constants/chat.constants';

interface MessageInputProps {
  activeChatId: string
}

function MessengerInput(props: MessageInputProps) {
  const {
    activeChatId
  } = props;

  const inputRef = useRef(null);

  const dispatch = useDispatch();
  const chat = useSelector(selectChatData)(activeChatId);
  const userInfo = useSelector(selectUserProfile);

  const sendHandler = () => {
    if (!chat?.sending) {
      dispatch(new SendMessage({
        chat_channel: activeChatId,
        invite_code: chat?.chatInfo?.invite_code,
        message: {
          contents: chat?.message,
          origin: GLYMPSE_PRO_CHAT_ORIGIN,
          author: userInfo?.displayName,
        }
      }));
    }
  };

  const onKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      sendHandler();
    }
  };

  const onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(new ChatNewMessageUpdate({
      chat_channel: activeChatId,
      message: event.target.value
    }));
  };

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  useEffect(() => {
    if (!chat?.sending && chat?.sent && !chat?.chatInfo?.completed) {
      inputRef?.current?.focus();
    }
  }, [chat?.sending, chat?.sent, chat?.chatInfo?.completed]);

  const chatDisabled = chat?.sending || chat?.chatInfo?.completed;

  return (
    <div className="message-input-wrapper">
      {
        chat?.loaded && chat?.error && !chat?.sending ? (
          <div className="text-danger font-sm mb-1">
            Failed to send message.
            <CButton color="link" size="sm" className="p-0 ml-1" onClick={sendHandler}>Retry</CButton>
          </div>
        ) : null
      }
      <div className="message-input-container">
        <textarea
          className="message-input"
          ref={inputRef}
          placeholder={!chatDisabled ? "Write a message..." : "This chat is disabled"}
          onKeyPress={onKeyPress}
          onChange={onChange}
          value={chat?.message}
          disabled={chatDisabled}
        />
        {
          !chatDisabled ? (
            <CButton onClick={sendHandler} disabled={chat?.sending}>
              {
                !chat?.sending ? <CIcon name="cil-paper-plane" size="xl"/> : <CSpinner className="primary-color" size="xl" />
              }
            </CButton>
          ) : null
        }
      </div>
    </div>
  );
}


export default MessengerInput;
